import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=26c4e2bf&scoped=true&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"
import style0 from "./Page.vue?vue&type=style&index=0&id=26c4e2bf&scoped=true&lang=css&"
import style1 from "./Page.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c4e2bf",
  null
  
)

export default component.exports